import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAccountInfo } from 'actions/oldAccount';
import {toUrl} from 'utils/tool.js';

class LoginCheckLayer extends React.Component {

    constructor(props) {
        super(props);
        if (!this.props.account) {
            this.props.getAccountInfo(this.props.isAdmin,this.props.notMust);
        }
        this.hasLoad = false;
    }

    render() {

        if(this.props.notMust){
            return this.props.children;
        }

        if (!this.props.account) {
            return <div></div>;
        }
        if (this.props.account && !this.props.account.account_id) {
            const jump = this.props.isAdmin ? '/admin/login?next=':'/login?next=';
            toUrl(jump + encodeURIComponent(window.location.pathname));
            return <div></div>;
        }
        return this.props.children;
    }

}

function select(state) {
    return {
        account: state.account.info
    };
}


function mapDispatchToProps(dispatch) {
    return {
        getAccountInfo: bindActionCreators(getAccountInfo, dispatch)
    };
}

export default connect(select, mapDispatchToProps)(LoginCheckLayer);



// WEBPACK FOOTER //
// ./src/components/LoginCheckLayer.js